import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

const scrollButtons = document.querySelectorAll('[data-scroll-button]')

Array.prototype.forEach.call(scrollButtons, scrollButton => {
  scrollButton.addEventListener('click', event => {
    event.preventDefault()
    const id = scrollButton.getAttribute('href')
    const section = document.querySelector(id)
    section.scrollIntoView({ behavior: 'smooth' })
  })
})
